import React from 'react';
import PropTypes from 'prop-types';
import find from 'lodash/find';
import get from 'lodash/get';
import cn from 'classnames';
import { EXPORT_TEXTS } from '@Services/ExportService/ExportConstants';
import Auth from '@Services/Auth';
import { ButtonWithIcon } from '@els/els-react--button';
import NotifyDialogsService from '@Containers/Dialogs/NotifyDialogsService';
import ExportRequestManager from '@Services/ExportRequestManager';
import './AvailabilityProviders.scss';

const EXPORT_TYPE = 'ChemQuote';
const CHECK_PROVIDERS = ['eMolecules', 'Labnetwork', 'Sigma Aldrich'];

function ChemquoteProviderListItem({ closeMenu, providers, structure, onClick = () => null }) {
  const checkIfShouldBeDisplayed = () => {
    const isChemQuoteEnabled = get(Auth.getUser(), 'details.settings.chemquoteEnabled');
    const isCheckProviderPresent = !!find(providers, (provider) => provider.show && CHECK_PROVIDERS.includes(provider.label));
    return isChemQuoteEnabled && isCheckProviderPresent;
  };

  const showExportBusyInfoDialog = () => {
    NotifyDialogsService.openModalWindow({
      title: EXPORT_TEXTS.busyInfoDialogTitle,
      text: EXPORT_TEXTS.busyInfoDialogText,
      confirmText: EXPORT_TEXTS.busyInfoDialogButton,
      type: 'info',
      backdrop: 'static',
      onConfirm: () => {
        if (typeof closeMenu === 'function') {
          closeMenu();
        }
      },
      trackingOptions: {
        component: 'Export',
      },
    });
  };

  const providerClickHandler = (event) => {
    event.preventDefault();
    onClick();

    if (ExportRequestManager.isBusy(EXPORT_TYPE)) {
      showExportBusyInfoDialog();
      return;
    }

    ExportRequestManager.sendExportRequest(EXPORT_TYPE, {
      databaseId: structure.databaseId,
      ids: [get(structure, 'details.id')],
    });

    if (typeof closeMenu === 'function') {
      closeMenu();
    }
  };

  if (!checkIfShouldBeDisplayed()) return null;

  return (
    <li role="menuitem" className="availability-provider-list-item u-els-display-flex" aria-label="Top commercial suppliers" tabIndex="0">
      <span className="column-provider--logo">
        <div className="provider-image chemquote" />
      </span>
      <ButtonWithIcon
        data-e2e="novartis-chemquote"
        className={cn('provider-link provider-link--chemquote', 'e2e-novartis-chemquote')}
        sprite="UpRight"
        iconRight
        type="link"
        linkIconSize="xs"
        onClick={providerClickHandler}>
        Novartis ChemQuote
      </ButtonWithIcon>
    </li>
  );
}

ChemquoteProviderListItem.propTypes = {
  closeMenu: PropTypes.func.isRequired,
  providers: PropTypes.array.isRequired,
  structure: PropTypes.object.isRequired,
  onClick: PropTypes.func,
};

export default ChemquoteProviderListItem;
